// Subcategory Banners Carousel JS
(function () {
  if (window.luxoSubcategoryBannersMounted) return;
  window.luxoSubcategoryBannersMounted = true;

  document.addEventListener('DOMContentLoaded', function () {
    var swiperWrappers = document.querySelectorAll('.subcategory-banners .swiper-wrapper');
    if (!swiperWrappers.length) return;

    document.querySelectorAll('.subcategory-banners').forEach(carousel => {
      if (carousel.dataset.trackingBound === 'true') return;

      const headingText = carousel.querySelector('.subcategory-banners__heading h2')?.textContent.trim() || '';
      carousel.addEventListener('click', function (event) {
        if (typeof window.luxoPublishEvent !== 'function') return;

        const banner = event.target.closest('.subcategory-banner__link[href], .subcategory-banner[href]');
        if (!banner || !carousel.contains(banner)) return;

        window.luxoPublishEvent('subcategory_banner_clicked', {
          category: headingText,
          banner_title: banner.getAttribute('title') || banner.textContent.trim(),
          banner_url: banner.href
        });
      });

      carousel.dataset.trackingBound = 'true';
    });

    swiperWrappers.forEach(swiperWrapper => {
      if (swiperWrapper.classList.contains('initialized') || swiperWrapper.dataset.swiperScheduled === 'true') return;
      swiperWrapper.dataset.swiperScheduled = 'true';

      const swiperContainer = swiperWrapper.closest('.swiper-container') || swiperWrapper;
      const carousel = swiperWrapper.closest('.subcategory-banners');
      const fallbackDelay = Number(swiperWrapper.getAttribute('data-swiper-fallback-delay')) || 30000;
      const useNativeMobileScroll =
        document.body.classList.contains('collection') &&
        window.matchMedia('(max-width: 749px)').matches &&
        !swiperContainer.classList.contains('no-swiper');

      if (useNativeMobileScroll) return;

      window.luxoRunNearElement(swiperContainer, () => {
        if (swiperWrapper.classList.contains('initialized')) return;

        window.luxoLoadSwiper().then(() => {
          const bannerInterval = swiperWrapper.getAttribute('data-interval');
          const bannerSpeed = swiperWrapper.getAttribute('data-transition');
          const autoplay = swiperWrapper.getAttribute('data-autoplay') === 'true';
          const equalizeHeight = swiperWrapper.getAttribute('data-equal-height') === 'true';
          const slidesPerViewMobile = swiperWrapper.getAttribute('data-slides-per-view-mobile');
          const scrollbar = carousel?.querySelector('.swiper-scrollbar');
          const nextButton = carousel?.querySelector('.swiper-button-next');
          const prevButton = carousel?.querySelector('.swiper-button-prev');

          const addScrollBarClass = (swiper) => {
            if (swiper.isBeginning && swiper.isEnd) {
              swiper.el.classList.remove('visible-scrollbar');
            } else {
              swiper.el.classList.add('visible-scrollbar');
            }
          };
          const onSlideChange = (swiper) => {
            if (swiper.isBeginning) {
              swiper.navigation?.prevEl?.classList?.add('swiper-button-disabled', 'hidden');
            } else {
              swiper.navigation?.prevEl?.classList?.remove('swiper-button-disabled', 'hidden');
            }

            if (swiper.isEnd) {
              swiper.navigation?.nextEl?.classList?.add('swiper-button-disabled', 'hidden');
            } else {
              swiper.navigation?.nextEl?.classList?.remove('swiper-button-disabled', 'hidden');
            }
          };
          const setSwiperHeight = (swiper) => {
            const wrapperHeight = swiper?.wrapperEl?.offsetHeight;
            if (wrapperHeight) swiper?.wrapperEl?.style?.setProperty('height', Math.ceil(wrapperHeight) + 'px');
          };
          const unsetSwiperHeight = (swiper) => {
            swiper?.wrapperEl?.style?.removeProperty('height');
          };

          new Swiper(swiperContainer, {
            slidesPerView: 8,
            spaceBetween: 10,
            loop: false,
            autoplay: autoplay ? {
              delay: bannerInterval,
              disableOnInteraction: false,
            } : false,
            scrollbar: scrollbar ? {
              el: scrollbar,
              hide: false,
              draggable: true,
              snapOnRelease: true,
            } : false,
            navigation: nextButton && prevButton ? {
              nextEl: nextButton,
              prevEl: prevButton
            } : false,
            speed: bannerSpeed,
            breakpoints: {
              0: {
                slidesPerView: slidesPerViewMobile ? parseInt(slidesPerViewMobile) : 3,
              },
              550: {
                slidesPerView: 3,
              },
              640: {
                slidesPerView: 4,
              },
              768: {
                slidesPerView: 5,
              },
              1024: {
                slidesPerView: 6,
              },
              1280: {
                slidesPerView: 'auto',
              },
            },
            on: {
              init: function () {
                swiperWrapper.classList.add('initialized');
                onSlideChange(this);
                addScrollBarClass(this);
                if (equalizeHeight) setSwiperHeight(this);
              },
              resize: function () {
                addScrollBarClass(this);
                if (equalizeHeight) setSwiperHeight(this);
              },
              beforeInit: unsetSwiperHeight,
              beforeResize: unsetSwiperHeight,
              slideChange: onSlideChange
            }
          });
        });
      }, { fallbackDelay });
    });

  });
})();
